import React from "react";
import logger from "logger";
import * as taskservice from "Utils/TaskService";

export default function(props) {
  const { task } = props;
  return (
    <>
      {task.taskstatusdetail.errorlogs && (
        <div>
          <div
            className="infokey enlargeonhover"
            onClick={(event) => {
              taskservice.showAllNotifications(
                task.taskstatusdetail.errorlogs
              );
            }}
          >
            Notifications
            <span style={{"float": "right", "fontWeight": "bold", "color": "red"}}>
              [See All]
            </span>
          </div>
          {Object.keys(task.taskstatusdetail.errorlogs).map((key,index) => {
            if(index>5) {
              return null;
            }
            const value = task.taskstatusdetail.errorlogs[key];
            return (
              <div
                className="infovalue"
                style={{"fontSize": "10px", "maxWidth": "250px"}}
              >
                -{value}
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}
